import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DataStoreProvider } from './context/DataStoreContext';
import Login from './pages/login/Login';
import Signup from './pages/signup/Signup';
import Home from './pages/Home';
import TutorProfile from './pages/tutor/Profile';
import StudentProfile from './pages/student/Profile';
import BecomeTutor from './pages/become-tutor/BecomeTutor';
import ForgotPassword from './pages/forgot-password/ForgotPassword';
import Navbar from './components/Navbar';
import { UserProvider } from './context/UserContext';
import VerifyEmailComponent from './pages/verify/VerifyEmail';
import Theme from './components/Theme';
import Splash from './pages/Splash';
import { FirebaseAuthService } from './services/FirebaseAuthService';
import { FirebaseTutorProfileService } from './services/FirebaseTutorProfileService';
import PublicOnlyRoute from './PublicOnlyRoute';
import { AppRoutes } from './routes';
import { featureFlags } from './utils/featureFlags';

const authService = new FirebaseAuthService();
const tutorProfileService = new FirebaseTutorProfileService();

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider authService={authService}>
        <DataStoreProvider tutorProfileService={tutorProfileService}>
          <UserProvider>
            <Theme>
              <Navbar />
              <Routes>
                {/* Waitlist page */}
                <Route path={AppRoutes.WAITLIST} element={<Splash />} />
                
                {/* Public marketing pages - always available */}
                <Route path={AppRoutes.HOME} element={<Home />} />
                <Route path={AppRoutes.BECOME_TUTOR} element={<BecomeTutor />} />

                {/* Auth routes - controlled by showAuthRoutes flag */}
                {featureFlags.showAuthRoutes && (
                  <>
                    <Route path={AppRoutes.LOGIN} element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
                    <Route path={AppRoutes.SIGNUP} element={<PublicOnlyRoute><Signup /></PublicOnlyRoute>} />
                    <Route path={AppRoutes.FORGOT_PASSWORD} element={<PublicOnlyRoute><ForgotPassword /></PublicOnlyRoute>} />
                  </>
                )}

                {/* If auth routes are disabled, redirect them to waitlist */}
                {!featureFlags.showAuthRoutes && (
                  <>
                    <Route path={AppRoutes.LOGIN} element={<Navigate to={AppRoutes.WAITLIST} replace />} />
                    <Route path={AppRoutes.SIGNUP} element={<Navigate to={AppRoutes.WAITLIST} replace />} />
                    <Route path={AppRoutes.FORGOT_PASSWORD} element={<Navigate to={AppRoutes.WAITLIST} replace />} />
                  </>
                )}

                {/* Protected app routes - always available */}
                <Route path={AppRoutes.TUTOR_PROFILE} element={<TutorProfile />} />
                <Route path={AppRoutes.STUDENT_PROFILE} element={<StudentProfile />} />
                <Route path={AppRoutes.VERIFY} element={<VerifyEmailComponent />} />
              </Routes>
            </Theme>
          </UserProvider>
        </DataStoreProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;
